import React from "react";

import styles from "./SocialLink.module.css";
import Language from "../utils/Language";

const PLATFORMS = [
  {
    key: "social_unityas",
    href: "https://assetstore.unity.com/publishers/28565",
    accent: "linear-gradient(135deg, #f472b6, #a855f7)",
    glyph: "U"
  },
  {
    key: "social_googleplay",
    href: "https://play.google.com/store/apps/dev?id=5079797572205129369",
    accent: "linear-gradient(135deg, #34d399, #22d3ee)",
    glyph: "▶"
  },
  {
    key: "social_youtube",
    href: "https://www.youtube.com/channel/UCRGkeAE958X-JiQa5ukWpSw/videos",
    accent: "linear-gradient(135deg, #f87171, #f59e0b)",
    glyph: "Y"
  }
];

function SocialLink() {
  return (
    <section className={styles.Section}>
      <div className={styles.Head}>
        <h2 className={styles.Title}>{Language.GetString("social_title")}</h2>
        <p className={styles.Subtitle}>
          {Language.GetString("social_subtitle")}
        </p>
      </div>
      <div className={styles.Grid}>
        {PLATFORMS.map(p => (
          <a
            key={p.key}
            href={p.href}
            target="_blank"
            rel="noreferrer"
            className={styles.Card}
            style={{ "--card-accent": p.accent }}
          >
            <div className={styles.Icon}>{p.glyph}</div>
            <div className={styles.Body}>
              <span className={styles.Name}>{Language.GetString(p.key)}</span>
              <span className={styles.Arrow}>↗</span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}

export default SocialLink;
